<template>
  <el-container>
    <el-aside>
      <SiderMenu />
    </el-aside>
    <el-container class="mars-ape-layout">
      <el-header class="mars-ape-layout-header">
        <Header />
      </el-header>
      <el-main>
        <div v-if="isRootRoutePath">
          <PageHeaderLayout>
            <div class="main-page-content">
                <el-row :gutter="40" class="panel-group">
                  <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
                    <div class="card-panel" @click="handleSetLineChartData('newVisitis')">
                      <div class="card-panel-icon-wrapper icon-people">
                        <i class="iconfont el-icon-shopping-cart-full" style="font-size:38px"></i>
                      </div>
                      <div class="card-panel-description">
                        <div class="card-panel-text">
                          今日订单数
                        </div>
                        <count-to :start-val="0" :end-val="user_number" :duration="2600" class="card-panel-num" />
                        <div class="card-panel-trend">
                          <span :class="orderTrend > 0 ? 'up' : 'down'">
                            <i :class="orderTrend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                            {{Math.abs(orderTrend)}}%
                          </span>
                          较昨日
                          <el-tooltip effect="dark" content="与昨日同期数据对比" placement="top">
                            <i class="el-icon-question" style="margin-left: 5px; cursor: pointer;"></i>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
                    <div class="card-panel" @click="handleSetLineChartData('messages')">
                      <div class="card-panel-icon-wrapper icon-message">
                        <i class="iconfont el-icon-money" style="font-size:38px"></i>
                      </div>
                      <div class="card-panel-description">
                        <div class="card-panel-text">
                          今日销售额
                        </div>
                        <count-to :start-val="0" :end-val="book_number" :duration="3000" class="card-panel-num" />
                        <div class="card-panel-trend">
                          <span :class="salesTrend > 0 ? 'up' : 'down'">
                            <i :class="salesTrend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                            {{Math.abs(salesTrend)}}%
                          </span>
                          较昨日
                          <el-alert v-if="salesTrend < -10" title="销售额下降超过10%" type="warning" show-icon :closable="false" class="trend-alert"></el-alert>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
                    <div class="card-panel" @click="handleSetLineChartData('purchases')">
                      <div class="card-panel-icon-wrapper icon-money">
                        <i class="iconfont el-icon-user" style="font-size:38px"></i>
                      </div>
                      <div class="card-panel-description">
                        <div class="card-panel-text">
                          新增用户
                        </div>
                        <count-to :start-val="0" :end-val="sale_total" :duration="3200" class="card-panel-num" />
                        <div class="card-panel-trend">
                          <span :class="userTrend > 0 ? 'up' : 'down'">
                            <i :class="userTrend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                            {{Math.abs(userTrend)}}%
                          </span>
                          较昨日
                          <el-alert v-if="userTrend > 20" title="用户增长超过20%" type="success" show-icon :closable="false" class="trend-alert"></el-alert>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
                    <div class="card-panel" @click="handleSetLineChartData('shoppings')">
                      <div class="card-panel-icon-wrapper icon-shopping">
                        <i class="iconfont el-icon-goods" style="font-size:38px"></i>
                      </div>
                      <div class="card-panel-description">
                        <div class="card-panel-text">
                          商品总数
                        </div>
                        <count-to :start-val="0" :end-val="sale_numer" :duration="3600" class="card-panel-num" />
                        <div class="card-panel-trend">
                          <span :class="productTrend > 0 ? 'up' : 'down'">
                            <i :class="productTrend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                            {{Math.abs(productTrend)}}%
                          </span>
                          较昨日
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="32" style="margin-bottom: 32px;">
                  <el-col :span="24">
                    <div class="chart-wrapper">
                      <div class="chart-header">
                        <h3>全球客户分布</h3>
                        <div class="map-controls">
                          <el-select v-model="mapView" size="small" style="width: 120px" @change="updateMapView">
                            <el-option label="全球视图" value="world"></el-option>
                            <el-option label="中国" value="china"></el-option>
                            <el-option label="美国" value="usa"></el-option>
                          </el-select>
                          <el-date-picker
                            v-model="mapDateRange"
                            type="daterange"
                            size="small"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="updateMapData">
                          </el-date-picker>
                          <el-button size="small" type="primary" @click="exportMapData">
                            <i class="el-icon-download"></i> 导出Excel
                          </el-button>
                          <el-button size="small" @click="exportMapPDF">
                            <i class="el-icon-document"></i> 导出PDF
                          </el-button>
                        </div>
                      </div>
                      <div class="map-container">
                        <div id="customerMap" style="height: 500px;"></div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="32">
                  <el-col :xs="24" :sm="24" :lg="12">
                    <div class="chart-wrapper sales-analytics">
                      <div class="chart-header">
                        <div class="header-left">
                          <h3>销售趋势分析</h3>
                          <p class="chart-subtitle">实时监控销售数据变化趋势</p>
                        </div>
                        <div class="chart-controls">
                          <el-radio-group v-model="salesTimeRange" size="small" @change="updateSalesChart" class="time-selector">
                            <el-radio-button label="day">今日</el-radio-button>
                            <el-radio-button label="week">本周</el-radio-button>
                            <el-radio-button label="month">本月</el-radio-button>
                            <el-radio-button label="year">本年</el-radio-button>
                          </el-radio-group>
                          <el-select v-model="salesMetric" size="small" style="width: 140px" @change="updateSalesChart" class="metric-selector">
                            <el-option label="销售额 (¥)" value="amount"></el-option>
                            <el-option label="订单量 (单)" value="orders"></el-option>
                            <el-option label="客单价 (¥)" value="average"></el-option>
                            <el-option label="转化率 (%)" value="conversion"></el-option>
                          </el-select>
                          <el-dropdown @command="handleSalesExport" class="export-dropdown">
                            <el-button size="small" type="primary">
                              导出数据<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="excel">
                                <i class="el-icon-document"></i> Excel格式
                              </el-dropdown-item>
                              <el-dropdown-item command="pdf">
                                <i class="el-icon-tickets"></i> PDF报表
                              </el-dropdown-item>
                              <el-dropdown-item command="image">
                                <i class="el-icon-picture-outline"></i> 图片格式
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <div class="sales-metrics-row">
                        <div class="metric-card">
                          <div class="metric-icon sales-icon">
                            <i class="el-icon-money"></i>
                          </div>
                          <div class="metric-content">
                            <div class="metric-value">{{ salesTodayDisplay }}</div>
                            <div class="metric-label">今日销售额</div>
                            <div class="metric-change" :class="salesTrend >= 0 ? 'positive' : 'negative'">{{ salesTrend >= 0 ? '+' : '' }}{{ salesTrend }}% 较昨日</div>
                          </div>
                        </div>
                        <div class="metric-card">
                          <div class="metric-icon orders-icon">
                            <i class="el-icon-shopping-bag-2"></i>
                          </div>
                          <div class="metric-content">
                            <div class="metric-value">{{ todayOrderCount }}</div>
                            <div class="metric-label">今日订单</div>
                            <div class="metric-change" :class="orderTrend >= 0 ? 'positive' : 'negative'">{{ orderTrend >= 0 ? '+' : '' }}{{ orderTrend }}% 较昨日</div>
                          </div>
                        </div>
                        <div class="metric-card">
                          <div class="metric-icon conversion-icon">
                            <i class="el-icon-pie-chart"></i>
                          </div>
                          <div class="metric-content">
                            <div class="metric-value">{{ paidRateDisplay }}</div>
                            <div class="metric-label">今日付款单占比</div>
                            <div class="metric-change" :class="paidOrderTrend >= 0 ? 'positive' : 'negative'">{{ paidOrderTrend >= 0 ? '+' : '' }}{{ paidOrderTrend }}% 较昨日</div>
                          </div>
                        </div>
                      </div>
                      <div class="chart-container">
                        <day-chart :chart-data="dayChartData" />
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :lg="12">
                    <div class="chart-wrapper category-analytics">
                      <div class="chart-header">
                        <div class="header-left">
                          <h3>商品分类分析</h3>
                          <p class="chart-subtitle">各品类销售表现对比分析</p>
                        </div>
                        <div class="chart-controls">
                          <el-select v-model="categoryMetric" size="small" style="width: 140px" @change="updateCategoryChart" class="metric-selector">
                            <el-option label="销售额分析" value="amount"></el-option>
                            <el-option label="销量对比" value="quantity"></el-option>
                            <el-option label="利润分析" value="profit"></el-option>
                            <el-option label="增长率" value="growth"></el-option>
                          </el-select>
                          <el-button-group class="view-toggle">
                            <el-button size="small" :type="categoryView === 'chart' ? 'primary' : ''" @click="categoryView = 'chart'">
                              <i class="el-icon-pie-chart"></i>
                            </el-button>
                            <el-button size="small" :type="categoryView === 'table' ? 'primary' : ''" @click="categoryView = 'table'">
                              <i class="el-icon-menu"></i>
                            </el-button>
                          </el-button-group>
                          <el-dropdown @command="handleCategoryExport" class="export-dropdown">
                            <el-button size="small" type="primary">
                              导出<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="excel">Excel报表</el-dropdown-item>
                              <el-dropdown-item command="pdf">PDF分析</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                      <div class="category-summary">
                        <div class="summary-item">
                          <span class="summary-label">总分类数</span>
                          <span class="summary-value">{{ categorySummaryCount }}</span>
                        </div>
                        <div class="summary-item">
                          <span class="summary-label">热销分类</span>
                          <span class="summary-value hot">{{ categoryHotName }}</span>
                        </div>
                        <div class="summary-item">
                          <span class="summary-label">次高销售额</span>
                          <span class="summary-value growth">{{ categorySecondName }}</span>
                        </div>
                      </div>
                      <div class="chart-container" v-show="categoryView === 'chart'">
                        <bar-chart :chart-source="barChartSource" />
                      </div>
                      <div class="category-table" v-show="categoryView === 'table'">
                        <el-table :data="categoryData" style="width: 100%" class="professional-table">
                          <el-table-column prop="category" label="分类" width="120">
                            <template slot-scope="scope">
                              <div class="category-cell">
                                <div :class="'category-dot ' + scope.row.color"></div>
                                {{scope.row.category}}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="amount" label="销售额">
                            <template slot-scope="scope">
                              <span class="amount-text">¥{{scope.row.amount.toLocaleString()}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="percentage" label="占比" width="100">
                            <template slot-scope="scope">
                              <div class="percentage-bar">
                                <div class="bar-fill" :style="{width: scope.row.percentage + '%', backgroundColor: scope.row.colorCode}"></div>
                                <span class="percentage-text">{{scope.row.percentage}}%</span>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column prop="trend" label="趋势" width="80">
                            <template slot-scope="scope">
                              <el-tag :type="scope.row.trend > 0 ? 'success' : 'danger'" size="mini">
                                <i :class="scope.row.trend > 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                                {{Math.abs(scope.row.trend)}}%
                              </el-tag>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="32" style="margin-top: 32px;">
                  <el-col :xs="24" :sm="24" :lg="12">
                    <div class="chart-wrapper">
                      <div class="chart-header">
                        <h3>用户分析</h3>
                        <div class="chart-controls">
                          <el-select v-model="userMetric" size="small" style="width: 120px" @change="updateUserChart">
                            <el-option label="新增用户" value="new"></el-option>
                            <el-option label="活跃用户" value="active"></el-option>
                            <el-option label="付费用户" value="paid"></el-option>
                          </el-select>
                          <el-button size="small" type="primary" @click="exportUserData">导出数据</el-button>
                        </div>
                      </div>
                      <div class="user-analysis">
                        <div class="user-metrics">
                          <div class="metric-item">
                            <div class="metric-title">新增用户</div>
                            <div class="metric-value">{{newUsers}}</div>
                            <div class="metric-trend" :class="newUsersTrend > 0 ? 'up' : 'down'">
                              {{newUsersTrend}}%
                            </div>
                          </div>
                          <div class="metric-item">
                            <div class="metric-title">活跃用户</div>
                            <div class="metric-value">{{activeUsers}}</div>
                            <div class="metric-trend" :class="activeUsersTrend > 0 ? 'up' : 'down'">
                              {{activeUsersTrend}}%
                            </div>
                          </div>
                          <div class="metric-item">
                            <div class="metric-title">付费用户</div>
                            <div class="metric-value">{{paidUsers}}</div>
                            <div class="metric-trend" :class="paidUsersTrend > 0 ? 'up' : 'down'">
                              {{paidUsersTrend}}%
                            </div>
                          </div>
                        </div>
                        <div class="user-chart">
                          <div class="user-chart-placeholder">
                            <el-empty description="用户图表开发中" :image-size="80"></el-empty>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :lg="12">
                    <div class="chart-wrapper">
                      <div class="chart-header">
                        <h3>热销商品TOP10</h3>
                        <div class="chart-controls">
                          <el-select v-model="productMetric" size="small" style="width: 120px" @change="updateTopProducts">
                            <el-option label="销售额" value="amount"></el-option>
                            <el-option label="销量" value="quantity"></el-option>
                            <el-option label="利润" value="profit"></el-option>
                          </el-select>
                          <el-button size="small" type="primary" @click="exportTopProducts">导出数据</el-button>
                        </div>
                      </div>
                      <div class="top-products">
                        <el-table :data="topProducts" style="width: 100%">
                          <el-table-column prop="rank" label="排名" width="80"></el-table-column>
                          <el-table-column prop="name" label="商品名称"></el-table-column>
                          <el-table-column prop="category" label="分类" width="120"></el-table-column>
                          <el-table-column prop="sales" label="销量" width="120"></el-table-column>
                          <el-table-column prop="amount" label="销售额" width="120"></el-table-column>
                          <el-table-column prop="profit" label="利润" width="120"></el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </el-col>
                </el-row>
            </div>
          </PageHeaderLayout>
        </div>

        <router-view />
      </el-main>
      <el-footer>
        <Footer />
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
import SiderMenu from "./SiderMenu";
import Header from "./Header";
import Footer from "./Footer";
import CountTo from 'vue-count-to'
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import { mapGetters } from "vuex";
import DayChart from '@/components/admin/components/DayChart'
import BarChart from '@/components/admin/components/BarChart'
import * as echarts from 'echarts'
import 'echarts/map/js/china'
import 'echarts/map/js/world'
const lineChartData = {
  monthDatas: {
    expectedData: [396, 396, 396, 396, 396, 396, 400,396, 396, 399, 396, 396, 396, 396, 396, 396, 400,396, 396, 399,396, 396, 399, 396, 396, 396, 396, 396, 396, 400,500],
    actualData: [12900, 12007, 2291, 1154, 1162, 2140, 2145, 2291, 1154, 1162, 2140, 2145, 12291, 1154, 1162, 2140, 2145, 2291, 1154, 1162, 2140, 2145, 2291, 1154, 1162,12145, 2291, 21154, 1162, 1154, 1162]
  },
  newVisitis: {
    expectedData: [100, 120, 161, 134, 105, 160, 165],
    actualData: [120, 82, 91, 154, 162, 140, 145]
  },
  dayDatas: {
    expectedData: [1200, 12007, 2291, 1154, 1162, 2140, 2145, 2291, 1154, 1162, 2140, 2145, 12291, 1154, 1162, 2140, 2145, 2291, 1154, 1162, 2140, 2145, 2291],
    actualData: [100, 1207, 291, 114, 112, 140, 145, 2291, 1154, 1162, 2140, 2145, 12291, 1154, 1162, 2140, 2145, 2291, 1154, 1162, 2140, 2145, 2291]
  },
  messages: {
    expectedData: [200, 192, 120, 144, 160, 130, 140],
    actualData: [180, 160, 151, 106, 145, 150, 130]
  },
  purchases: {
    expectedData: [80, 100, 121, 104, 105, 90, 100],
    actualData: [120, 90, 100, 138, 142, 130, 130]
  },
  shoppings: {
    expectedData: [130, 140, 141, 142, 145, 150, 160],
    actualData: [120, 82, 91, 154, 162, 140, 130]
  }
}
export default {
  components: {
    CountTo,
    SiderMenu,
    Header,
    Footer,
    PageHeaderLayout,
    DayChart,
    BarChart
  },
  data() {
    return {
      loadingStaus: true,
      selectedList: [],
      coverimage: "",
      depth: 0,
      uploadHeaders: {},
      dialogVisible: false,
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      sale_numer:0,
      book_number:0,
      sale_total:0,
      user_number:0,
      mapChart: null,
      monthChartData: lineChartData.monthDatas,
      dayChartData: lineChartData.dayDatas,
      // 表格列表数据
      scheduleList: [],
      defaultFormData: {
        display_name: "",
        parent_id: 0,
      },
      // 表单结构
      formData: {},
      // 表单验证
      rules: {
        display_name: [
          { required: true, message: "输入任务名称", trigger: "blur" },
        ],
        done_time: [
          { required: true, message: "输入任务标识", trigger: "blur" },
        ],
      },
      salesTimeRange: 'day',
      mapView: 'world',
      orderTrend: 15.5,
      salesTrend: -8.2,
      userTrend: 23.8,
      productTrend: 0,
      salesTodayDisplay: '¥0',
      todayOrderCount: 0,
      paidRateDisplay: '0%',
      paidOrderTrend: 0,
      categorySummaryCount: 0,
      categoryHotName: '—',
      categorySecondName: '—',
      barChartSource: null,
      savedDayChart: null,
      topProducts: [],
      mapDateRange: [],
      mapData: [],
      newUsers: 0,
      activeUsers: 0,
      paidUsers: 0,
      newUsersTrend: 0,
      activeUsersTrend: 0,
      paidUsersTrend: 0,
      userChartData: [],
      salesMetric: 'amount',
      categoryMetric: 'amount',
      userMetric: 'new',
      productMetric: 'amount',
      categoryView: 'chart',
      categoryData: [],
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    isRootRoutePath: function () {
      return this.$route.path == "/";
    },
  },
  methods: {
    async loadDashboard() {
      if (!this.isRootRoutePath) return
      try {
        const res = await this.$api.post('/service/dashboard/home', {})
        if (!this.$apiSuccess(res) || !res.data || !res.data.detail) return
        const d = res.data.detail
        this.user_number = Number(d.today_order_count) || 0
        this.book_number = Math.round(Number(d.today_sales_total) || 0)
        this.sale_total = Number(d.today_new_customers) || 0
        this.sale_numer = Number(d.customer_file_total) || 0
        this.orderTrend = Number(d.order_trend_pct) || 0
        this.salesTrend = Number(d.sales_trend_pct) || 0
        this.userTrend = Number(d.user_trend_pct) || 0
        this.productTrend = Number(d.file_trend_pct) || 0
        this.salesTodayDisplay = '¥' + (Number(d.today_sales_total) || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })
        // 评审 G9：GMV 分币种展示——CNY/USD 混合合计口径失真
        const byCur = d.today_sales_by_currency || []
        if (byCur.length > 1) {
          const parts = byCur.map((r) => (r.currency === 'USD' ? '$' : '¥') + (Number(r.amount) || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }))
          this.salesTodayDisplay = parts.join(' + ')
        }
        this.todayOrderCount = Number(d.today_order_count) || 0
        const to = Number(d.today_order_count) || 0
        const tp = Number(d.today_paid_orders) || 0
        const pr = to > 0 ? Math.round((tp / to) * 1000) / 10 : 0
        this.paidRateDisplay = pr + '%'
        this.paidOrderTrend = Number(d.paid_order_trend_pct) || 0
        this.mapData = (d.map_by_country || []).map((r) => ({
          name: r.name,
          value: Number(r.value) || 0
        }))
        const rows = d.category_agg || []
        const totalAmt = Number(d.category_total) || 0
        this.categorySummaryCount = rows.length
        this.categoryHotName = rows[0] ? rows[0].category : '—'
        this.categorySecondName = rows[1] ? rows[1].category : '—'
        const dotPalette = [
          { color: 'blue', colorCode: '#409EFF' },
          { color: 'purple', colorCode: '#722ED1' },
          { color: 'green', colorCode: '#52C41A' },
          { color: 'pink', colorCode: '#EB2F96' },
          { color: 'orange', colorCode: '#FA8C16' },
          { color: 'cyan', colorCode: '#13C2C2' },
          { color: 'red', colorCode: '#F5222D' }
        ]
        this.categoryData = rows.map((r, i) => {
          const amt = Number(r.amount) || 0
          const pct = totalAmt > 0 ? Math.round((amt / totalAmt) * 1000) / 10 : 0
          const pal = dotPalette[i % dotPalette.length]
          return {
            category: r.category || '—',
            amount: amt,
            percentage: pct,
            trend: 0,
            color: pal.color,
            colorCode: pal.colorCode
          }
        })
        this.barChartSource = rows.length
          ? {
              categories: rows.map((r) => r.category),
              values: rows.map((r) => Number(r.amount) || 0),
              seriesName: '订单行销售额'
            }
          : { categories: ['暂无数据'], values: [0], seriesName: '订单行销售额' }
        this.topProducts = (d.top_products || []).map((r, i) => ({
          rank: i + 1,
          name: r.name || '—',
          category: r.category || '—',
          sales: Number(r.sales) || 0,
          amount: Math.round((Number(r.amount) || 0) * 100) / 100,
          profit: 0
        }))
        this.newUsers = Number(d.today_new_customers) || 0
        this.activeUsers = Number(d.active_users_today) || 0
        this.paidUsers = Number(d.paying_customers_distinct) || 0
        this.newUsersTrend = Number(d.user_trend_pct) || 0
        this.activeUsersTrend = 0
        this.paidUsersTrend = Number(d.paid_order_trend_pct) || 0
        const ch = d.chart_7d || {}
        this.dayChartData = {
          xAxisData: ch.labels || [],
          expectedData: (ch.orders || []).map((v) => Number(v) || 0),
          actualData: (ch.amounts || []).map((v) => Number(v) || 0),
          legend: ['订单数', '销售额(本币)']
        }
        this.savedDayChart = { ...this.dayChartData }
        this.$nextTick(() => {
          if (this.mapChart) {
            this.mapChart.dispose()
            this.mapChart = null
          }
          setTimeout(() => this.initCustomerMap(), 200)
        })
      } catch (e) {
        /* 拦截器已提示 */
      }
    },
    handleSetLineChartData(type) {
      if (this.savedDayChart && this.savedDayChart.xAxisData && this.savedDayChart.xAxisData.length) {
        this.dayChartData = { ...this.savedDayChart }
        return
      }
      this.dayChartData = lineChartData[type]
    },
    initCustomerMap() {
      if (!document.getElementById('customerMap')) {
        console.error('Map container not found')
        return
      }
      
      const mapChart = echarts.init(document.getElementById('customerMap'))
      const mapSum = this.mapData.reduce((s, x) => s + (Number(x.value) || 0), 0) || 1
      const mapVals = this.mapData.map((x) => Number(x.value) || 0)
      const mapMax = mapVals.length ? Math.max(...mapVals, 1) : 1
      const option = {
        backgroundColor: '#f5f5f5',
        title: {
          text: '全球客户分布热力图',
          left: 'center',
          textStyle: {
            color: '#333',
            fontSize: 18
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            if (params.value) {
              return `${params.name}<br/>客户数量：${params.value}<br/>占比：${((params.value / mapSum) * 100).toFixed(1)}%`
            }
            return `${params.name}<br/>暂无数据`
          }
        },
        visualMap: {
          min: 0,
          max: mapMax,
          left: 'left',
          top: 'bottom',
          text: ['多', '少'],
          calculable: true,
          inRange: {
            color: ['#E6F3FF', '#409EFF', '#1890FF', '#0066CC']
          },
          textStyle: {
            color: '#333'
          }
        },
        series: [
          {
            name: '客户数量',
            type: 'map',
            map: this.mapView === 'world' ? 'world' : 'china',
            roam: true,
            scaleLimit: {
              min: 0.5,
              max: 3
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              itemStyle: {
                areaColor: '#ff6b6b'
              },
              label: {
                show: true,
                color: '#fff'
              }
            },
            data: this.mapData
          }
        ]
      }
      mapChart.setOption(option)
      
      // 添加点击事件
      mapChart.on('click', (params) => {
        this.showRegionDetail(params.name, params.value)
      })
      
      window.addEventListener('resize', () => {
        mapChart.resize()
      })
      
      this.mapChart = mapChart
    },
    showRegionDetail(name, value) {
      this.$alert(`地区：${name}\n客户数量：${value || 0}`, '地区详情', {
        confirmButtonText: '确定'
      })
    },
    updateMapView() {
      this.$nextTick(() => {
        this.initCustomerMap()
      })
    },
    exportMapData() {
      const sum = this.mapData.reduce((s, x) => s + (Number(x.value) || 0), 0) || 1
      const data = this.mapData.map(item => ({
        地区: item.name,
        客户数量: item.value,
        占比: `${((item.value / sum) * 100).toFixed(1)}%`
      }))
      this.downloadExcel(data, '客户分布数据')
    },
    exportMapPDF() {
      this.$message.success('PDF导出功能正在开发中...')
    },
    downloadExcel(data, filename) {
      // 模拟Excel导出
      const csvContent = this.convertToCSV(data)
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `${filename}.csv`)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    convertToCSV(data) {
      if (!data.length) return ''
      const headers = Object.keys(data[0]).join(',')
      const rows = data.map(row => Object.values(row).join(','))
      return [headers, ...rows].join('\n')
    },
    updateMapData() {
      this.$nextTick(() => {
        this.initCustomerMap()
      })
    },
    updateSalesChart() {
      this.loadDashboard()
    },
    updateCategoryChart() {
      this.loadDashboard()
    },
    updateUserChart() {
      this.loadDashboard()
    },
    updateTopProducts() {
      this.loadDashboard()
    },
    handleSalesExport(command) {
      switch(command) {
        case 'excel':
          this.exportSalesExcel()
          break
        case 'pdf':
          this.exportSalesPDF()
          break
        case 'image':
          this.exportSalesImage()
          break
        default:
          this.$message.info('导出功能开发中...')
      }
    },
    handleCategoryExport(command) {
      switch(command) {
        case 'excel':
          this.exportCategoryExcel()
          break
        case 'pdf':
          this.exportCategoryPDF()
          break
        default:
          this.$message.info('导出功能开发中...')
      }
    },
    exportSalesExcel() {
      const data = [
        { 时间: '09:00', 销售额: 1250, 订单量: 15, 客单价: 83.33 },
        { 时间: '10:00', 销售额: 2100, 订单量: 28, 客单价: 75.00 },
        { 时间: '11:00', 销售额: 1850, 订单量: 22, 客单价: 84.09 },
        { 时间: '12:00', 销售额: 3200, 订单量: 45, 客单价: 71.11 }
      ]
      this.downloadExcel(data, '销售趋势数据')
    },
    exportSalesPDF() {
      this.$message.success('PDF报表导出功能正在开发中...')
    },
    exportSalesImage() {
      this.$message.success('图片导出功能正在开发中...')
    },
    exportCategoryExcel() {
      const data = this.categoryData.map(item => ({
        分类: item.category,
        销售额: `¥${item.amount.toLocaleString()}`,
        占比: `${item.percentage}%`,
        趋势: `${item.trend > 0 ? '+' : ''}${item.trend}%`
      }))
      this.downloadExcel(data, '商品分类数据')
    },
    exportCategoryPDF() {
      this.$message.success('PDF分析报告正在生成中...')
    },
    exportUserData() {
      const data = [
        { 指标: '新增用户', 数量: this.newUsers, 趋势: `${this.newUsersTrend}%` },
        { 指标: '活跃用户', 数量: this.activeUsers, 趋势: `${this.activeUsersTrend}%` },
        { 指标: '付费用户', 数量: this.paidUsers, 趋势: `${this.paidUsersTrend}%` }
      ]
      this.downloadExcel(data, '用户分析数据')
    },
    exportTopProducts() {
      const data = this.topProducts.map(item => ({
        排名: item.rank,
        商品名称: item.name,
        分类: item.category,
        销量: item.sales,
        销售额: `¥${item.amount}`,
        利润: `¥${item.profit}`
      }))
      this.downloadExcel(data, '热销商品数据')
    },
  },
  watch: {
    '$route.path'(p) {
      if (p === '/') {
        this.loadDashboard()
      }
    }
  },
  async mounted() {
    if (!this.isRootRoutePath) {
      return
    }
    await this.loadDashboard()
  },
  beforeDestroy() {
    if (this.mapChart) {
      this.mapChart.dispose()
      this.mapChart = null
    }
  }
};
</script>
<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 128px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);
    transition: all 0.3s;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

.card-panel-trend {
  font-size: 12px;
  margin-top: 8px;
  color: #909399;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .up {
    color: #67C23A;
    font-weight: bold;
  }

  .down {
    color: #F56C6C;
    font-weight: bold;
  }

  i {
    margin-right: 4px;
  }

  .trend-alert {
    margin-top: 5px;
    padding: 2px 8px;
    font-size: 10px;
    height: auto;
    line-height: 1.2;
  }
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
}

.map-controls {
  display: flex;
  gap: 10px;
  align-items: center;
  
  .el-date-picker {
    width: 240px;
  }
}

.chart-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.chart-wrapper {
  background: #fff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.08);
  margin-bottom: 25px;
  transition: all 0.3s;
  border: 1px solid #ebeef5;

  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.12);
    transform: translateY(-2px);
  }
}

.map-container {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
  border: 1px solid #ebeef5;

  &:hover {
    box-shadow: 0 4px 16px 0 rgba(0,0,0,.15);
  }
}

.user-analysis {
  .user-metrics {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    
    .metric-item {
      flex: 1;
      text-align: center;
      padding: 20px;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      border-radius: 8px;
      margin: 0 10px;
      transition: all 0.3s;
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      }
      
      &:first-child {
        margin-left: 0;
      }
      
      &:last-child {
        margin-right: 0;
      }
      
      .metric-title {
        font-size: 14px;
        color: #606266;
        margin-bottom: 8px;
        font-weight: 500;
      }
      
      .metric-value {
        font-size: 28px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 8px;
      }
      
      .metric-trend {
        font-size: 12px;
        
        &.up {
          color: #67C23A;
        }
        
        &.down {
          color: #F56C6C;
        }
      }
    }
  }
  
  .user-chart {
    margin-top: 20px;
    height: 300px;
    
    .user-chart-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #fafafa;
      border-radius: 8px;
      border: 1px dashed #d9d9d9;
    }
  }
}

.top-products {
  .el-table {
    margin-top: 16px;
    
    .el-table__header th {
      background: #f5f7fa;
      color: #606266;
      font-weight: 600;
    }
    
    .el-table__row:hover {
      background: #f5f7fa;
    }
  }
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
  
  .chart-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .map-controls,
  .chart-controls {
    flex-wrap: wrap;
  }
}

// 添加预警样式
.trend-alert {
  margin-top: 5px !important;
  padding: 2px 8px !important;
  font-size: 10px !important;
  height: auto !important;
  line-height: 1.2 !important;
  
  .el-alert__content {
    padding: 0 !important;
  }
  
  .el-alert__title {
    font-size: 10px !important;
    margin: 0 !important;
  }
}

// 销售分析专业样式
.sales-analytics {
  .chart-header {
    .header-left {
      h3 {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 4px;
      }
      
      .chart-subtitle {
        font-size: 14px;
        color: #666;
        margin: 0;
        font-weight: 400;
      }
    }
    
    .chart-controls {
      .time-selector {
        margin-right: 15px;
        
        .el-radio-button__inner {
          padding: 8px 16px;
          font-weight: 500;
        }
      }
      
      .metric-selector {
        margin-right: 15px;
        
        .el-input__inner {
          font-weight: 500;
        }
      }
      
      .export-dropdown {
        .el-button {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          font-weight: 500;
        }
      }
    }
  }
  
  .sales-metrics-row {
    display: flex;
    gap: 20px;
    margin: 25px 0;
    
    .metric-card {
      flex: 1;
      background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      border: 1px solid #e8ecf1;
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0,0,0,0.1);
      }
      
      .metric-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        
        i {
          font-size: 24px;
          color: white;
        }
        
        &.sales-icon {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        }
        
        &.orders-icon {
          background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        }
        
        &.conversion-icon {
          background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
        }
      }
      
      .metric-content {
        flex: 1;
        
        .metric-value {
          font-size: 24px;
          font-weight: bold;
          color: #1a1a1a;
          line-height: 1;
          margin-bottom: 4px;
        }
        
        .metric-label {
          font-size: 13px;
          color: #666;
          margin-bottom: 6px;
        }
        
        .metric-change {
          font-size: 12px;
          font-weight: 600;
          
          &.positive {
            color: #52c41a;
          }
          
          &.negative {
            color: #ff4d4f;
          }
        }
      }
    }
  }
  
  .chart-container {
    margin-top: 20px;
    min-height: 300px;
  }
}

// 商品分类分析专业样式
.category-analytics {
  .chart-header {
    .header-left {
      h3 {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 4px;
      }
      
      .chart-subtitle {
        font-size: 14px;
        color: #666;
        margin: 0;
        font-weight: 400;
      }
    }
    
    .chart-controls {
      .metric-selector {
        margin-right: 15px;
      }
      
      .view-toggle {
        margin-right: 15px;
        
        .el-button {
          padding: 8px 12px;
          
          i {
            font-size: 16px;
          }
        }
      }
      
      .export-dropdown {
        .el-button {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          font-weight: 500;
        }
      }
    }
  }
  
  .category-summary {
    display: flex;
    justify-content: space-between;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    color: white;
    
    .summary-item {
      text-align: center;
      flex: 1;
      
      .summary-label {
        display: block;
        font-size: 14px;
        opacity: 0.9;
        margin-bottom: 8px;
      }
      
      .summary-value {
        display: block;
        font-size: 20px;
        font-weight: bold;
        
        &.hot {
          color: #ffd700;
        }
        
        &.growth {
          color: #90ee90;
        }
      }
    }
  }
  
  .chart-container {
    min-height: 350px;
    margin-top: 20px;
  }
  
  .category-table {
    margin-top: 20px;
    
    .professional-table {
      .el-table__header {
        th {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          color: #495057;
          font-weight: 600;
          border: none;
        }
      }
      
      .el-table__body {
        tr {
          &:hover {
            background: #f8f9ff !important;
          }
          
          td {
            border: none;
            padding: 15px 10px;
          }
        }
      }
      
      .category-cell {
        display: flex;
        align-items: center;
        
        .category-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          margin-right: 8px;
          
          &.blue { background: #409EFF; }
          &.purple { background: #722ED1; }
          &.green { background: #52C41A; }
          &.pink { background: #EB2F96; }
          &.orange { background: #FA8C16; }
          &.cyan { background: #13C2C2; }
          &.red { background: #F5222D; }
        }
      }
      
      .amount-text {
        font-weight: 600;
        color: #1a1a1a;
      }
      
      .percentage-bar {
        position: relative;
        width: 100%;
        height: 20px;
        background: #f0f0f0;
        border-radius: 10px;
        overflow: hidden;
        
        .bar-fill {
          height: 100%;
          border-radius: 10px;
          transition: width 0.3s ease;
        }
        
        .percentage-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 11px;
          font-weight: 600;
          color: #333;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .sales-analytics {
    .sales-metrics-row {
      flex-direction: column;
      gap: 15px;
    }
    
    .chart-header {
      .chart-controls {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        
        .time-selector,
        .metric-selector {
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }
  }
  
  .category-analytics {
    .category-summary {
      flex-direction: column;
      gap: 15px;
    }
    
    .chart-header {
      .chart-controls {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
      }
    }
  }
}
</style>

<style lang="stylus">
.mod-index {
  border-radius: 5px;
  background: #fff;
  padding: 24px;
  min-height: 800px;
  line-height: 1.5;

  p {
    margin: 0;
  }

  h3 {
    margin-block-start: 0;
    margin-block-end: 0.5em;
  }

  .xm-gt img {
    height: 240px;
    margin-left: -16px;
  }

  .jx-zz img {
    height: 400px;
    margin-top: 24px;
    margin-right: 24px;
  }
}

.el-container {
  background: #f0f2f5;
}

.el-aside {
  min-height: 100vh;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  position: relative;
  width: auto !important;
  z-index: 10;
  transitionall: 0.3s;
  background: #001529;
}

.el-header {
  height: 64px !important;
  padding: 0px;
  width: 100%;
}

.el-main {
  padding: 0px;
  margin: 24px;
  overflow: inherit;
  flexnone: @css { !important };
  min-height: 720px;
}

.main-page-content {
  border-radius: 5px;
  background: #ffffff;
  padding: 24px;
}

.el-footer {
  height: auto !important;
}

</style>